import React from "react";
import { FunctionField } from "react-admin";

import { CustomFieldField } from "./CustomFieldField";

export const CustomFieldColumn = ({ customField }) => (
	<FunctionField
		key={`custom_${customField.key}`}
		sortable={false}
		render={(record) => {
			const field = record?.custom_fields?.find((cf) => cf.field_id === customField.id);
			const customFieldRecord = {
				...customField,
				...field,
				field_id: customField.id,
			};
			return <CustomFieldField field={customFieldRecord} />;
		}}
	/>
);
